import common from "../../../utils/common";
import c from "../../../utils/constants";

class userPaymentDetailsController {
  constructor(UsersService, AppContextService, NotificationService) {
    "ngInject"

    this.usersService = UsersService;
    this.appContextService = AppContextService;
    this.notificationService = NotificationService;

    this.editMode = {
      walletBalance: {
        active: false,
        value: "",
      },
    };
  }

  enableEditMode(field) {
    this.editMode[field].active = true;

    this.editMode[field].value = this.user[field];
  }

  disableEditMode(field) {
    this.editMode[field].active = false;
    if (field == 'walletBalance') {
      const newBalance = parseInt(this.editMode[field].value);
      this.user[field] = newBalance;
    } else {
      this.user[field] = this.editMode[field].value;
    }
  }

  updateWalletBalance(field) {
    this.editMode[field].isLoading = true;
    this.usersService.updateWalletBalance(
        this.user.userId,
        this.user.walletBalance,
        (response) => {
          this.editMode[field].isLoading = false;
          this.editMode[field].active = false;
          this.notificationService.success("Update Successful");
          this.user = response.data;
        },
        (error) => {
          this.notificationService.error("Update Failed");
          this.editMode[field].isLoading = false;
        });
  }

  getPaymentDeviceType(type) {
    if (!type) return "-";

    switch (type) {
      case c.deviceType.DESKTOP:
        return "Desktop";
      case c.deviceType.MOBILE:
        return "Mobile Web";
      case c.deviceType.MOBILEAPP:
        return "Mobile App";
      default:
        return 'Unknown';
    }
  }

  getPaymentType(paymentType) {
    if (!paymentType) return "-";

    switch (paymentType) {
      case c.userPaymentType.SINGLE_ONE_OFF_JOB:
        return 'One-off Job';
      case c.userPaymentType.SINGLE_RECURRING_JOB:
        return 'Recurring Job';
      case c.userPaymentType.SINGLE_AU_PAIR_JOB:
        return 'Au Pair Job';
      case c.userPaymentType.SINGLE_PRIMARY_SCHOOL_TUTORING_JOB:
        return 'Primary School Tutoring Job';
      case c.userPaymentType.SINGLE_HIGH_SCHOOL_TUTORING_JOB:
        return 'High School Tutoring Job';
      case c.userPaymentType.ANNUAL_UNLIMITED_PAY_AS_YOU_GO:
        return '12 Months Unlimited Plan';
      case c.userPaymentType.SIX_MONTHS_UNLIMITED_PAY_AS_YOU_GO:
        return '6 Months Unlimited Plan';
      case c.userPaymentType.EXTEND_RECURRING_JOB:
        return 'Extend Recurring Job';
      case c.userPaymentType.ANNUAL_BABYSITTING_SUBSCRIPTION60:
      case c.userPaymentType.ANNUAL_BABYSITTING_SUBSCRIPTION120:
        return 'Babysitting Annual Subscription';
      case c.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION120:
        return 'Complete Childminding Annual Subscription';
      case c.userPaymentType.ANNUAL_TUTORING_SUBSCRIPTION90:
      case c.userPaymentType.ANNUAL_TUTORING_SUBSCRIPTION195:
        case c.userPaymentType.ANNUAL_TUTORING_SUBSCRIPTION245:
        return 'Tutoring Annual Subscription';
      case c.userPaymentType.ANNUAL_PRIMARY_SCHOOL_TUTORING_SUBSCRIPTION120:
        return 'Primary School Tutoring Annual Subscription';
      case c.userPaymentType.ANNUAL_HIGH_SCHOOL_TUTORING_SUBSCRIPTION195:
        return 'High School Tutoring Annual Subscription';
      case c.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION:
      case c.userPaymentType.ANNUAL_FOUNDING_MEMBER:
      case c.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION_120:
      case c.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION_150:
      case c.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION_180:
      case c.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION_180:
      case c.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION24:
      case c.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION30:
      case c.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION40:
      case c.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION180:
      case c.userPaymentType.ANNUAL_COMPLETE_FAMILY_CARE_SUBSCRIPTION120:
      case c.userPaymentType.ANNUAL_HELPER_STANDARD_SUBSCRIPTION50:
        return 'Annual Subscription';
      case c.userPaymentType.MONTHLY_HELPER_STANDARD_SUBSCRIPTION5:
        return 'Monthly Subscription';
      case c.userPaymentType.MONTHLY_BABYSITTING_SUBSCRIPTION40:
      case c.userPaymentType.MONTHLY_CHILDCARE_SUBSCRIPTION90:
      case c.userPaymentType.MONTHLY_CHILDCARE_SUBSCRIPTION60:
        return 'Monthly Subscription';
      case c.userPaymentType.QUARTERLY_STANDARD_SUBSCRIPTION:
      case c.userPaymentType.QUARTERLY_STANDARD_SUBSCRIPTION_60:
      case c.userPaymentType.QUARTERLY_STANDARD_SUBSCRIPTION_75:
      case c.userPaymentType.QUARTERLY_STANDARD_SUBSCRIPTION_90:
      case c.userPaymentType.QUARTERLY_HELPER_SUBSCRIPTION15:
      case c.userPaymentType.QUARTERLY_HELPER_SUBSCRIPTION20:
      case c.userPaymentType.THREE_MONTHS_HELPER_STANDARD_SUBSCRIPTION25:
        return 'Quarterly Subscription';
      case c.userPaymentType.ANNUAL_TUTORING_SUBSCRIPTION180:
        return 'Tutoring (In-home & Online)';
      case c.userPaymentType.ANNUAL_FAMILY_CARE_SUBSCRIPTION240:
        return 'Complete Childcare & Tutoring';
      case c.userPaymentType.ANNUAL_AU_PAIR_SUBSCRIPTION195:
        return 'Au Pair Annual Membership';
      case c.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION360:
        return 'Au Pair Premium Membership';
      case c.userPaymentType.QUARTERLY_BUSINESS_TIER1_SUBSCRIPTION_500:
        return 'Juggle St Pro - Single Site Quarterly';
      case c.userPaymentType.QUARTERLY_BUSINESS_TIER2_SUBSCRIPTION_500:
        return 'Juggle St Pro - Agency Quarterly';
      case c.userPaymentType.QUARTERLY_BUSINESS_TIER2_SUBSCRIPTION_750:
        return 'Juggle St Pro - Quarterly';
      case c.userPaymentType.ANNUAL_BUSINESS_TIER1_SUBSCRIPTION_1500:
        return 'Juggle St Pro - Single Site Annual';
      case c.userPaymentType.ANNUAL_BUSINESS_TIER2_SUBSCRIPTION_1500:
        return 'Juggle St Pro - Agency Annual';
      default:
        throw new Error(`Unsupported option: ${paymentType}`);
    }
  }

  formatDate(date) {
    if(!date) return false;

    return  common.formatDate(date);
  }

  hasPaymentsAdminAccess() {
    const appContext = this.appContextService.getAppContext();
    if (!appContext)
      return false;

    if (this.appContextService.hasPaymentsAdminAccess(appContext.roles))
      return true;
    else
      return false;
  }

  hasGlobalAdminAccess() {
    const appContext = this.appContextService.getAppContext();
    if (!appContext)
      return false;

    if (this.appContextService.hasGlobalAdminAccess(appContext.roles))
      return true;
    else
      return false;
  }

  cancelSubscription() {
    if (confirm('Are you sure you want to cancel this subscription?')) {

      this.usersService.cancelSubscription(
        this.user.userId,
        this.user,
        (response) => {
          this.notificationService.success("Update Successful");
          this.user = response.data;
        },
        (error) => {
          this.notificationService.error(error.data ? error.data : "Update Failed");
        });
    }
  }

}

export default userPaymentDetailsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-payment-details/user-payment-details.controller.js
 **/